import {
  CSP_DASHBOARD_LOADING,
  CSP_DASHBOARD_LOADED,
  CSP_DASHBOARD_FAILED,
  CSP_SYNC_TRIGGERING,
  CSP_SYNC_TRIGGERED,
  CSP_SYNC_TRIGGER_FAILED,
  CSP_TENANTS_LOADED,
  CSP_UNMAPPED_TENANTS_LOADED,
  CSP_TENANT_UPDATING,
  CSP_TENANT_UPDATED,
  CSP_TENANT_UPDATE_FAILED,
  CSP_NOTIFICATIONS_LOADED,
  CSP_SETTINGS_LOADING,
  CSP_SETTINGS_LOADED,
  CSP_SETTINGS_SAVING,
  CSP_SETTINGS_SAVED,
  CSP_SETTINGS_FAILED,
  CSP_PRODUCTS_LOADING,
  CSP_PRODUCTS_LOADED,
  CSP_PRODUCTS_FAILED,
  CSP_PRODUCT_UPDATING,
  CSP_PRODUCT_UPDATED,
  CSP_PRODUCT_UPDATE_FAILED,
} from '../components/actions/cspRenewalsTypes'

const initialState = {
  // Dashboard
  loading: true,
  dashboard: null,
  // Sync
  syncTriggering: false,
  lastSyncJobId: null,
  // Tenants
  tenants: [],
  unmappedTenants: [],
  updatingTenantId: null,
  // Notifications
  notifications: [],
  // Settings
  settings: null,
  settingsLoading: false,
  settingsSaving: false,
  // Products (curation)
  products: [],
  productsLoading: false,
  updatingStockCode: null,
  // Notification queue (Sprint 3)
  queue: [],
  queueLoading: false,
}

const cspRenewalsReducer = (state = initialState, action) => {
  switch (action.type) {
    // ─── Dashboard ─────────────────────────────
    case CSP_DASHBOARD_LOADING:
      state.loading = true
      return state
    case CSP_DASHBOARD_LOADED:
      state.loading = false
      state.dashboard = action.payload
      return state
    case CSP_DASHBOARD_FAILED:
      state.loading = false
      return state

    // ─── Sync ──────────────────────────────────
    case CSP_SYNC_TRIGGERING:
      state.syncTriggering = true
      return state
    case CSP_SYNC_TRIGGERED:
      state.syncTriggering = false
      state.lastSyncJobId = action.payload?.jobId
      return state
    case CSP_SYNC_TRIGGER_FAILED:
      state.syncTriggering = false
      return state

    // ─── Tenants ───────────────────────────────
    case CSP_TENANTS_LOADED:
      state.tenants = action.payload
      return state
    case CSP_UNMAPPED_TENANTS_LOADED:
      state.unmappedTenants = action.payload
      return state
    case CSP_TENANT_UPDATING:
      state.updatingTenantId = action.payload
      return state
    case CSP_TENANT_UPDATED:
      state.updatingTenantId = null
      return state
    case CSP_TENANT_UPDATE_FAILED:
      state.updatingTenantId = null
      return state

    // ─── Notifications ─────────────────────────
    case CSP_NOTIFICATIONS_LOADED:
      state.notifications = action.payload
      return state

    // ─── Settings ──────────────────────────────
    case CSP_SETTINGS_LOADING:
      state.settingsLoading = true
      return state
    case CSP_SETTINGS_LOADED:
      state.settingsLoading = false
      state.settings = action.payload
      return state
    case CSP_SETTINGS_SAVING:
      state.settingsSaving = true
      return state
    case CSP_SETTINGS_SAVED:
      state.settingsSaving = false
      state.settings = action.payload
      return state
    case CSP_SETTINGS_FAILED:
      state.settingsLoading = false
      state.settingsSaving = false
      return state

    // ─── Products ──────────────────────────────
    case CSP_PRODUCTS_LOADING:
      state.productsLoading = true
      return state
    case CSP_PRODUCTS_LOADED:
      state.productsLoading = false
      state.products = action.payload
      return state
    case CSP_PRODUCTS_FAILED:
      state.productsLoading = false
      return state
    case CSP_PRODUCT_UPDATING:
      state.updatingStockCode = action.payload
      return state
    case CSP_PRODUCT_UPDATED: {
      state.updatingStockCode = null
      const idx = state.products.findIndex((p) => p.stockCode === action.payload.stockCode)
      if (idx >= 0) {
        state.products[idx].isExcluded = action.payload.isExcluded
        state.products[idx].isManuallyOverridden = true
      }
      return state
    }
    case CSP_PRODUCT_UPDATE_FAILED:
      state.updatingStockCode = null
      return state

    // ─── Notification queue ────────────────────
    case 'CSP_QUEUE_LOADING':
      state.queueLoading = true
      return state
    case 'CSP_QUEUE_LOADED':
      state.queueLoading = false
      state.queue = action.payload
      return state
    case 'CSP_QUEUE_FAILED':
      state.queueLoading = false
      return state

    default:
      return state
  }
}

export default cspRenewalsReducer
